
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./fm-api.cjs.production.min.js')
} else {
  module.exports = require('./fm-api.cjs.development.js')
}
